export default "__VITE_ASSET__jUWTX9Vl__"